import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProgress } from '../contexts/ProgressContext';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import './Settings.css';

const Settings = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const { progress } = useProgress();
  const navigate = useNavigate();

  const [settings, setSettings] = useState({
    emailNotifications: true,
    courseUpdates: true,
    newsletter: false,
    darkMode: true
  });

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [message, setMessage] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');

  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleToggle = (setting) => {
    setSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
    setMessage('Paramètres mis à jour !');
    setTimeout(() => setMessage(''), 2000);
  };

  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value
    });
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordMessage('Les mots de passe ne correspondent pas');
      return;
    }
    if (passwordData.newPassword.length < 6) {
      setPasswordMessage('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    setPasswordMessage('Mot de passe modifié avec succès !');
    setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    setTimeout(() => setPasswordMessage(''), 3000);
  };

  const totalProgress = progress?.totalProgress || 0;

  return (
    <div className="dashboard-layout">
      {/* SIDEBAR PRO */}
      <aside className="dashboard-sidebar">
        <div className="sidebar-logo" onClick={() => navigate('/dashboard')}>
          <span className="logo-text">F12IA</span>
          <span className="logo-tm">™</span>
        </div>

        <div className="sidebar-user">
          <div className="user-avatar">
            {user?.firstName?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="user-info">
            <span className="user-name">{user?.firstName || 'Utilisateur'}</span>
            <span className="user-role">Membre PRO</span>
          </div>
        </div>

        <nav className="sidebar-nav-pro">
          <div className="nav-label">MENU</div>
          <div className="nav-item" onClick={() => navigate('/dashboard')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg></span>
            <span className="nav-text">Tableau de bord</span>
          </div>

          <div className="nav-label">FORMATIONS</div>
          <div className="nav-item" onClick={() => navigate('/formation/chatgpt')}>
            <span className="nav-icon chatgpt-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729z"/></svg></span>
            <span className="nav-text">ChatGPT</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/formation/claude')}>
            <span className="nav-icon claude-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128-2.251-3.614-.144-.072-4.794.893-.071.158.503 2.332.014.13 2.023 3.178z"/></svg></span>
            <span className="nav-text">Claude Code</span>
          </div>
          <div className="nav-item fusion-nav" onClick={() => navigate('/formation/fusion')}>
            <span className="nav-icon fusion-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg></span>
            <span className="nav-text">Fusion</span>
            <span className="nav-badge-pro">PRO</span>
          </div>

          <div className="nav-label">COMPTE</div>
          <div className="nav-item" onClick={() => navigate('/profile')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg></span>
            <span className="nav-text">Mon profil</span>
          </div>
          <div className="nav-item active" onClick={() => navigate('/settings')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg></span>
            <span className="nav-text">Paramètres</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/resources')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg></span>
            <span className="nav-text">Ressources</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/certificate')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M8 14l-2 8 6-3 6 3-2-8"/></svg></span>
            <span className="nav-text">Certificat</span>
          </div>
        </nav>

        <div className="sidebar-progress-pro">
          <div className="progress-header">
            <span className="progress-title">Progression</span>
            <span className="progress-value">{Math.round(totalProgress)}%</span>
          </div>
          <div className="progress-bar-pro">
            <div className="progress-fill-pro" style={{ width: `${totalProgress}%` }} />
          </div>
        </div>

        <div className="sidebar-bottom">
          <div className="nav-item logout-item" onClick={handleLogout}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span>
            <span className="nav-text">Déconnexion</span>
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="dashboard-main">
        <div className="dashboard-topbar">
          <div className="topbar-left">
            <h1 className="page-title">Paramètres</h1>
          </div>
          <div className="topbar-right">
            <span className="welcome-text">Bienvenue, <strong>{user?.firstName}</strong></span>
          </div>
        </div>

        <div className="dashboard-content">
          <div className="settings-container">

            {/* Notifications */}
            <div className="settings-section">
              <h3>Notifications</h3>
              {message && <div className="success-message small">{message}</div>}

              <div className="settings-list">
                <div className="setting-item">
                  <div className="setting-info">
                    <h4>Notifications par email</h4>
                    <p>Recevoir des emails pour les mises à jour importantes</p>
                  </div>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={settings.emailNotifications}
                      onChange={() => handleToggle('emailNotifications')}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>

                <div className="setting-item">
                  <div className="setting-info">
                    <h4>Mises à jour des cours</h4>
                    <p>Être notifié quand un nouveau module est disponible</p>
                  </div>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={settings.courseUpdates}
                      onChange={() => handleToggle('courseUpdates')}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>

                <div className="setting-item">
                  <div className="setting-info">
                    <h4>Newsletter</h4>
                    <p>Recevoir nos conseils et astuces IA chaque semaine</p>
                  </div>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={settings.newsletter}
                      onChange={() => handleToggle('newsletter')}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>
            </div>

            {/* Security */}
            <div className="settings-section">
              <h3>Sécurité</h3>

              {passwordMessage && (
                <div className={`message ${passwordMessage.includes('succès') ? 'success-message' : 'error-message'}`}>
                  {passwordMessage}
                </div>
              )}

              <form onSubmit={handlePasswordSubmit} className="password-form">
                <div className="form-group">
                  <label htmlFor="currentPassword">Mot de passe actuel</label>
                  <input
                    type="password"
                    id="currentPassword"
                    name="currentPassword"
                    value={passwordData.currentPassword}
                    onChange={handlePasswordChange}
                    placeholder="••••••••"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="newPassword">Nouveau mot de passe</label>
                  <input
                    type="password"
                    id="newPassword"
                    name="newPassword"
                    value={passwordData.newPassword}
                    onChange={handlePasswordChange}
                    placeholder="••••••••"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={passwordData.confirmPassword}
                    onChange={handlePasswordChange}
                    placeholder="••••••••"
                  />
                </div>

                <button type="submit" className="btn btn-primary">
                  Modifier le mot de passe
                </button>
              </form>
            </div>

            {/* Danger Zone */}
            <div className="settings-section danger-zone">
              <h3>Zone de danger</h3>
              <div className="danger-content">
                <div className="danger-info">
                  <h4>Supprimer mon compte</h4>
                  <p>Cette action est irréversible. Toutes vos données seront supprimées.</p>
                </div>
                <button className="btn btn-danger">
                  Supprimer le compte
                </button>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default Settings;
